import { render, staticRenderFns } from "./SurveyCheckboxButton.vue?vue&type=template&id=3507411d&"
import script from "./SurveyCheckboxButton.vue?vue&type=script&lang=js&"
export * from "./SurveyCheckboxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports